export enum EventTypeEnum {
    TenantChanged = "TENANT_CHANGED"
}